export const transferRequestStatusColor = {
  IN_REVIEW: "purple",
  CANCELLED: "gray",
  PENDING: "orange",
  EXECUTED: "green",
  FAILED: "red",
} as const;
